module.exports = __webpack_public_path__ + "AdobeStock_285202108_monitor2_iconcolors3.svg?eb1706c310b26ee44ebd87d74672ff9d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/landing/AdobeStock_285202108_monitor2_iconcolors3.svg
// module id = 35
// module chunks = 0